import { yellow } from "@styles/colors";

// Function to map plan_status to corresponding text
export const getStatusTextAndColor = (status: number) => {
  let statusText, color;
  switch (status) {
    case 0:
      statusText = 'Expired';
      color = '#EA5757';
      break;
    case 999:
      statusText = 'Unpaid';
      color = yellow;
      break;
    default:
      statusText = '';
      color = '';
      break;
  }
  return { statusText, color };
};

// Function to map plan_status to corresponding text and color
export const mapPlanStatusAndColor = (companies: any[]) => {
  return companies.map(
    (company: {
      plan_status: number;
      company_id: number;
      name: string;
      s_city: any;
      s_state: string;
      is_company_paid: boolean;
    }) => {
      const { statusText, color } = getStatusTextAndColor(company.plan_status);
      return {
        ...company,
        plan_status: statusText,
        color: color,
      };
    },
  );
};